<template>
  <div v-if="currentDaySchedule">
    <slot
      :not-available="notAvailable"
      :schedule="currentDaySchedule"
    >
      <div class="layout layout--icon layout--icon-less-spacing">
        <span class="icon fa-clock fal dark-gray" />
        <p>{{ currentDaySchedule }}</p>
      </div>
    </slot>
  </div>
</template>



<script>
  import moment from 'moment-timezone';
  import timeOfDay from '@/filters/time-of-day';
  import { mapGetters } from 'vuex';



  export default {
    name: 'CurrentDayMenuSchedule',

    props: {
      schedule: {
        type: Array,
        default() {
          return [];
        }
      }
    },

    computed: {
      ...mapGetters('locations', ['selectedLocation']),

      currentDaySchedule() {
        if (this.schedule.length === 0) {
          return null;
        }

        const dayparts = [];
        const today = this.selectedLocation.storeId ? moment().tz(this.selectedLocation.timeZone) : moment();
        const dayOfWeek = today.format('dddd');
        const schedules = this.schedule.filter(s => s.day === dayOfWeek);

        schedules.forEach((schedule) => {
          /*
            NOTE:
            If both startTime and endTime are 00:00:00, that means the whole day is NOT valid.
            If startTime is 00:00:00 and endTime is 23:59:59, that means the whole day is valid.
          */

          if (schedule.startTime === '00:00:00' && schedule.endTime === '23:59:59') {
            return;
          }

          if (schedule.startTime === '00:00:00' && schedule.endTime === '00:00:00') {
            dayparts.push('Not Available Today');
            return;
          }

          const startTimeDisplay = timeOfDay(schedule.startTime);
          const endTimeDisplay = timeOfDay(schedule.endTime);

          dayparts.push(`${startTimeDisplay}–${endTimeDisplay}`);
        });

        if (dayparts.length > 0) {
          return dayparts.join(', ');
        }


        return null;
      },

      notAvailable() {
        return this.currentDaySchedule === 'Not Available Today';
      }
    }
  };
</script>
